import { useMemo } from 'react';

import { __ } from '@eventespresso/i18n';
import { Factory } from '..';
import { useData } from '.';

import type { MoneyInputProps } from '@eventespresso/ui-components/src';
import type { PriceModifierProps } from '../../../..';

import './styles.scss';

export const Amount: React.FC<PriceModifierProps> = ({ price }) => {
	const { reverseCalculate, isDisabled, onChange } = useData({ price, field: 'amount' });

	const disabled = useMemo<boolean>(() => {
		return isDisabled || (reverseCalculate && price.isBasePrice) || price.isDefault;
	}, [isDisabled, reverseCalculate, price]);

	return (
		<Factory
			_type='Money'
			amount={price.amount || 0}
			aria-label={__('amount')}
			disabled={disabled}
			name='amount'
			onUpdate={onChange as unknown as MoneyInputProps['onUpdate']}
			placeholder={__('amount…')}
		/>
	);
};
